import { connect } from 'react-redux'
import History from '../../pages/nba/history/History'
import favInput from '../../assets/json/user-favorites/input.json'
import * as consts from '../../store/constant'

const mapStateToProps = state => {
    return {
        nba: state.NBAReducer ? state.NBAReducer.nba : null,
        breadCrumb: state.NBAReducer ? state.NBAReducer.breadCrumb : null,
        selectedProductDivision: state.ProductDivisionReducer ? state.ProductDivisionReducer.data : null,
        selectedCustomer: state.CustomerReducer ? state.CustomerReducer.data : null,
        selectedSBS: state.SBSReducer ? state.SBSReducer.data : null,
        favInput: favInput,
        favorites: state.FavoriteReducer ? state.FavoriteReducer.data : null
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setFavorite: (data) => dispatch({
            type: consts.SET_FAVORITE,
            data: data
        })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(History)
